import { useEffect, useState } from 'react';

import { SettingsAPI } from '../../api/settings.api';

export const useTenantSettings = (orgId: string | undefined) => {
  const [authorizationRequired, setAuthorizationRequired] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    (async () => {
      if (!orgId) {
        setAuthorizationRequired(true);
        return;
      }

      try {
        const result = await SettingsAPI.get(orgId);
        setAuthorizationRequired(result.data?.authorizationRequired ?? true);
      } catch {
        setAuthorizationRequired(true);
      }
    })();
  }, [orgId]);

  return { authorizationRequired };
};

export const useOrganizationId = (orgId: string | undefined) => {
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [currentCodingHeadingTag, setCurrentCodingHeadingTag] = useState<string>('h2');

  useEffect(() => {
    (async () => {
      if (!orgId) {
        setOrganizationId(null);
        return;
      }
      try {
        const result = await SettingsAPI.get(orgId);
        setOrganizationId(result.data?.oranizationId ?? null);
        setCurrentCodingHeadingTag(result.data?.currentCodingHeadingTag ?? 'h2');
      } catch {
        setOrganizationId(null);
      }
    })();
  }, [orgId]);

  return { organizationId, currentCodingHeadingTag };
};
